import logoImg from "/assets/images/logo.svg";
import type { FC } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { ILogo } from "../config";

/**
 * Логотип
 * @param baseClass
 * @param extraClasses
 * @param extraAttrs
 * @param imgSrc - путь для картинки логотипа
 * @param alt - альтернативное описание картинки/логотипа
 * @param width - ширина логотипа
 * @param height - высота логотипа
 * @param href - ссылка
 * @constructor
 */
export const Logo: FC<ILogo & IComponentBaseProps> = ({
  baseClass = "logo",
  extraClasses = "",
  extraAttrs = {},
  imgSrc = logoImg,
  alt = "Deepsum",
  width = 264,
  height = 40,
  href = "/",
}) => {
  const { getCN } = useCN(baseClass);

  return (
    <div className={getCN("", {}, [ `flex select-none max-w-[17rem] h-10 tablet:max-w-[33rem] tablet:h-[5rem] mobile:max-w-[15rem] mobile:h-7 ${extraClasses ?? ""}` ])} {...extraAttrs}>
      <a className={getCN("link", {}, [ "flex flex-shrink-0" ])} rel={"home"} href={href} aria-label={alt} title={alt}>
        <img className={getCN("image", {}, [ "w-full object-cover transition-all hover:scale-[1.025] hover:transform-gpu" ])} src={imgSrc} alt={alt} width={width} height={height} />
      </a>
    </div>
  );

};
